import React from "react";

import "./style.scss";
import { useDoctorSignature } from "queries/doctors";

export const FooterNotes = ({ dataRequest, signature }) => {
  const doctorId = dataRequest?.doctor_data?.uuid;
  const { data: signatureData } = useDoctorSignature(doctorId, {
    enabled: !!doctorId && !signature,
  });
  const signatureImage = signature || signatureData?.file;
  const doctorInitial =
    dataRequest?.doctor_data?.first_name +
    " " +
    dataRequest?.doctor_data?.last_name;
  const degree = dataRequest?.doctor_data?.title;
  return (
    <div className="templates-footer">
      <p>Sincerely,</p>
      <p className="templates-footer_signature">
        {signatureImage && (
          <img src={signatureImage} alt="download" />
        )}
      </p>
      <span>{`${doctorInitial}${degree ? `, ${degree}` : ""}`}</span>
    </div>
  );
};
